import { index as indexCategories } from "@/services/categories";

export default {
  namespaced: true,
  state: {
    categories: []
  },
  getters: {
    getCategories(state) {
      return state.categories;
    }
  },
  mutations: {
    setCategories(state, payload) {
      state.categories = payload;
    }
  },
  actions: {
    async loadCategories({ state }) {
      if (state.categories.length == 0) {
        try {
          const categories = await indexCategories({ list: true });
          state.categories = categories ? categories : [];
        } catch (error) {
          console.error("erro ao buscar categorias", error);
        }
      } else {
        return false;
      }
    }
  }
};
